  <template>
  <div class="index">
    <nav
      class="
        navbar navbar-expand-lg navbar-light
        fixed-top
        index-background-color index-navbar
      "
      ref="infoBox"
    >
      <!-- <div @click="change_selectPage('')">  -->
      <div
        v-if="
          selectPage == 'elecboard' ||
          selectPage == 'machstatus' ||
          selectPage == 'home' ||
          selectPage == 'heattreatmentinstant'
        "
        @click="slidebarChange()"
      >
        <img
          class="navbar-brand index-navbar-logo"
          style="cursor: pointer"
          src="../assets/kimaker_logo.png"
        />
      </div>
      <div
        v-else
        @click="
          change_selectPage('elecboard'),
            change_selectPageName(pageName.elecboard)
        "
      >
        <router-link :to="'elecboard'">
          <!-- <img class="navbar-brand" src="../assets/OFCO-logo.png" height="42px" /> -->
          <img
            class="navbar-brand index-navbar-logo"
            src="../assets/kimaker_logo.png"
          />
        </router-link>
      </div>
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <div style="width: 214px">
          <a
            class="index-color"
            style="
              font-size: 26px;
              font-family: dfyuanstd-w8, dfyuanstd-w7, dfyuanstd-w5;
            "
            >扣件智慧生產系統</a
          >
        </div>
        <ul class="navbar-nav mr-auto">
          <!-- <li class="nav-item">
            <a class="nav-link" style="cursor:pointer">行政管理系統</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" style="cursor:pointer">產品管理系統</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" style="cursor:pointer">進銷存系統</a>
          </li>
          <li class="nav-item">
            <router-link
              class="nav-link"
              v-show="pageAccess.sensorset"
              :to="'sensorset'"
              @click.prevent="clearSetTimeout"
            >感測器設定</router-link>
          </li>
          <li class="nav-item">
            <router-link
              class="nav-link"
              v-show="pageAccess.sensorchart"
              :to="'sensorchart'"
              @click.prevent="clearSetTimeout"
            >感測器圖表</router-link>
          </li>
          <li class="nav-item">
            <router-link
              class="nav-link"
              v-show="pageAccess.eboard"
              :to="'eboard'"
              @click.prevent="clearSetTimeout"
            >電子看板</router-link>
          </li>-->
        </ul>
        <form
          class="form-inline my-2 my-lg-0"
          style="font-family: dfyuanstd-w7, dfyuanstd-w5"
        >
          <div
            class="username"
            style="
              width: auto;
              text-align: right;
              margin-right: 15px;
              font-size: 16px;
              color: #ffffff;
            "
          >
            <p v-if="loginData.username === null" class="account m-0">
              HI, xxxx
            </p>
            <p v-else class="account m-0">您好！{{ loginData.username }}</p>
          </div>
          <div
            style="
              background-color: #4b8c80;
              width: 64px;
              height: 26px;
              line-height: 26px;
              text-align: center;
              border-radius: 5px;
              margin-right: 15px;
              cursor: pointer;
              font-size: 16px;
            "
            class=""
          >
            <a class="mx-0">繁中</a>
          </div>
          <!-- <a class="changepwd" style="float:right" @click.prevent="toggle_commonModalShow()">更改密碼</a> -->
          <div
            style="
              background-color: #4b8c80;
              text-align: center;
              width: 64px;
              height: 26px;
              line-height: 26px;
              border-radius: 5px;
              cursor: pointer;
              font-size: 16px;
            "
            @click.prevent="logout"
          >
            <a class="logout mx-0 right">登出</a>
          </div>
        </form>
      </div>
    </nav>
    <div class="container-fluid text-center">
      <div class="row content">
        <div
          v-if="slidebar"
          class="sidenav px-0 index-background-color"
          ref="sidenav"
          style="position: relative; width: 200px"
        >
          <ul class="sidenav" style="padding: 0px">
            <template
              v-for="(first_item, first_key) in sideBar"
              :keys="first_key"
            >
              <li
                v-if="pageAccess[first_item.code]"
                @mouseover="first_item.focus = true"
                @mouseleave="first_item.focus = false"
                :class="{ active: selectPage == first_item.code }"
              >
                <router-link
                  v-if="first_item.children.length == 0"
                  v-show="pageAccess[first_item.code]"
                  :class="{
                    active: first_item.focus,
                  }"
                  :to="first_item.code"
                  ><div class="m-auto">
                    <template v-if="first_item.code == 'home'"
                      ><b-icon icon="house-door-fill"></b-icon
                    ></template>
                    {{ first_item.name }}
                  </div></router-link
                >
                <a
                  v-else
                  :class="{
                    active: first_item.focus,
                  }"
                  class="right-arrow"
                  ><div class="m-auto">
                    {{ first_item.name }}
                  </div></a
                >
                <ul
                  v-if="first_item.focus"
                  :style="{ left: col_width + 'px', width: col_width + 'px' }"
                >
                  <li
                    v-for="(second_item, second_key) in first_item.children"
                    :key="second_key"
                    @mouseover="second_item.focus = true"
                    @mouseleave="second_item.focus = false"
                    @click="
                      !second_item.disabled && second_item.children.length == 0
                        ? ((first_item.focus = false),
                          (second_item.focus = false),
                          set_sideBarSelect([
                            first_item.code,
                            second_item.code,
                          ]))
                        : ''
                    "
                  >
                    <a
                      v-if="
                        second_item.children.length == 0 && second_item.disabled
                      "
                      class="disabled"
                      ><div class="m-auto">
                        {{ second_item.name }}
                      </div></a
                    >
                    <router-link
                      v-else-if="second_item.children.length == 0"
                      v-show="pageAccess[first_item.code]"
                      :to="first_item.code"
                      :disabled="second_item.disabled"
                      :class="{
                        active: second_item.focus,
                        disabled: second_item.disabled,
                      }"
                      ><div class="m-auto">
                        {{ second_item.name }}
                      </div></router-link
                    >
                    <a
                      v-else
                      :class="{
                        active: second_item.focus,
                      }"
                      class="right-arrow"
                      ><div class="m-auto">
                        {{ second_item.name }}
                      </div></a
                    >
                    <ul
                      v-if="first_item.focus && second_item.focus"
                      :style="{
                        left: col_width + 'px',
                        width: col_width + 'px',
                      }"
                    >
                      <li
                        v-for="(third_item, third_key) in second_item.children"
                        :key="third_key"
                        @mouseover="third_item.focus = true"
                        @mouseleave="third_item.focus = false"
                        @click="
                          !third_item.disabled
                            ? ((first_item.focus = false),
                              (second_item.focus = false),
                              (third_item.focus = false),
                              set_sideBarSelect([
                                first_item.code,
                                second_item.code,
                                third_item.code,
                              ]))
                            : ''
                        "
                      >
                        <a v-if="third_item.disabled" class="disabled"
                          ><div class="m-auto">
                            {{ third_item.name }}
                          </div></a
                        >
                        <router-link
                          v-else
                          v-show="pageAccess[first_item.code]"
                          :to="first_item.code"
                          :disabled="third_item.disabled"
                          :class="{
                            active: third_item.focus,
                            disabled: third_item.disabled,
                          }"
                          ><div class="m-auto">
                            {{ third_item.name }}
                          </div></router-link
                        >
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
            </template>
          </ul>
          <!-- <router-link v-show="pageAccess.elecboard" :to="'elecboard'">
            <p
              :class="{
                active: selectPage == 'elecboard' || selectPage == 'machstatus',
              }"
              id="elecboard"
              class="itemSelect"
            >
              {{ pageName.elecboard }}
            </p>
          </router-link> -->
          <!-- <router-link v-show="pageAccess.machstatus" :to="'machstatus'">
            <p
              :class="{active:selectPage=='machstatus'}"
              id="machstatus"
              class="itemSelect"
            >{{pageName.machstatus}}</p>
          </router-link> -->
          <!-- <router-link v-show="pageAccess.yieldstatistics" :to="'yieldstatistics'">
            <p
              :class="{active:selectPage=='yieldstatistics'}"
              id="yieldstatistics"
              class="itemSelect"
            >{{pageName.yieldstatistics}}</p>
          </router-link> -->
          <!-- <router-link v-show="pageAccess.activation" :to="'activation'">
            <p
              :class="{ active: selectPage == 'activation' }"
              id="activation"
              class="itemSelect"
              v-b-toggle.elecboard-toggle-2
            >
              {{ pageName.activation }}
            </p>
          </router-link>
          <b-collapse
            :id="'elecboard-toggle-2'"
            accordion="my-elecboard-accordion"
            role="tabpanel"
          >
          </b-collapse>
          <router-link v-show="pageAccess.operatelog" :to="'operatelog'">
            <p
              :class="{ active: selectPage == 'operatelog' }"
              id="operatelog"
              class="itemSelect"
            >
              {{ pageName.operatelog }}
            </p>
          </router-link>
          <router-link v-show="pageAccess.alarmhistory" :to="'alarmhistory'">
            <p
              :class="{ active: selectPage == 'alarmhistory' }"
              id="alarmhistory"
              class="itemSelect"
            >
              {{ pageName.alarmhistory }}
            </p>
          </router-link>
          <router-link
            v-show="pageAccess.workorderhistory"
            :to="'workorderhistory'"
          >
            <p
              :class="{ active: selectPage == 'workorderhistory' }"
              id="workorderhistory"
              class="itemSelect"
            >
              {{ pageName.workorderhistory }}
            </p>
          </router-link> -->
          <!-- <router-link v-show="pageAccess.machmalfunction" :to="'machmalfunction'">
            <p
              :class="{active:selectPage=='machmalfunction'}"
              id="machmalfunction"
              class="itemSelect"
            >{{pageName.machmalfunction}}</p>
          </router-link>-->
          <!-- <a href="#"> -->
          <p
            class="index-color index-version"
            style="
              background-color: transparent;
              padding: 0px;
              cursor: auto;
              position: absolute;
              bottom: 0px;
              left: 70.547px;
              font-size: 14px;
              font-family: 'dfyuanstd-w7';
            "
          >
            Ver 1.0
          </p>
          <!-- </a> -->
        </div>
        <div
          class="main"
          :style="{ width: slidebar ? 'calc(100% - 200px)' : '100%' }"
          ref="mainWidget"
        >
          <router-view></router-view>
        </div>
      </div>
      <!-- <div v-else class="row content">
        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 main">
          <router-view></router-view>
        </div>
      </div>-->
    </div>

    <!-- <a href="javascript:void(0)" class="closebtn" @click="changeSlide()">×</a> -->
    <!-- <div id="mySidebar" class="sidebar" :style="{ top: sideTop + 'px' }">
      <a href="#">機台概況</a>
      <a href="#">客戶管理</a>
      <a href="#">製程維護</a>
      <a href="#">關於</a>
    </div>-->

    <modal>
      <template v-slot:modalheader>
        <h5>更改密碼</h5>
      </template>
      <template v-slot:default>
        <div class="inputdiv">
          <label>舊密碼:</label>
          <div>
            <input
              type="password"
              id="change_oldpwd"
              class="form-control"
              style="background-color: white"
              v-model="ChangePwdmodal.old_pwd"
              v-bind:class="{
                wrongoldpwd: ChangePwdmodal.wrongStatus.oldisWrong,
              }"
            />
          </div>
        </div>
        <div class="inputdiv">
          <label>新密碼:</label>
          <div>
            <input
              type="password"
              id="change_newpwd"
              class="form-control"
              v-model="ChangePwdmodal.change_newpwd"
              v-bind:class="{
                wrongnewpwd1: ChangePwdmodal.wrongStatus.new1isWrong,
              }"
            />
          </div>
        </div>
        <div class="inputdiv">
          <label>再次輸入新密碼:</label>
          <div>
            <input
              type="password"
              id="change_newpwd2"
              class="form-control"
              v-model="ChangePwdmodal.change_newpwd2"
              v-bind:class="{
                wrongnewpwd2: ChangePwdmodal.wrongStatus.new2isWrong,
              }"
            />
          </div>
        </div>
      </template>
      <template v-slot:modalfooter>
        <div class="w-100">
          <b-button
            variant="light"
            size="sm"
            class="float-right"
            @click.prevent="reset(), toggle_commonModalShow()"
            >Close</b-button
          >
          <b-button
            variant="success"
            size="sm"
            class="float-right"
            style="margin-right: 10px"
            @click.prevent="changepwd"
            >更改密碼</b-button
          >
        </div>
      </template>
    </modal>
    <alertModal />
    <loadScreenModal />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import modal from "@/components/modal.vue";
import alertModal from "@/components/alertModal.vue";
import loadScreenModal from "@/components/loadScreenModal.vue";
export default {
  name: "index",
  data() {
    return {
      ChangePwdmodal: {
        old_pwd: "",
        change_newpwd: "",
        change_newpwd2: "",
        wrongStatus: {
          oldisWrong: false,
          new1isWrong: false,
          new2isWrong: false,
        },
      },
      slidebar: true,
      collapse_hover: {
        elecboard: false,
        "elecboard-heading": false,
        "elecboard-thread-rolling": false,
      },
      col_width: 0,
    };
  },
  created: function () {
    this.askNotification();
    this.selectOption();
    //////////////測試
    //  let sideBarKeys = Object.keys(this.sideBar);
    //   sideBarKeys.forEach((sideBarKey) => {
    //     if (this.sideBar[sideBarKey].children.length != 0) {
    //       this.collapse_hover[this.sideBar[sideBarKey].code] = false;
    //       this.sideBar[sideBarKey].children.forEach((children_item) => {
    //         this.collapse_hover[children_item.code] = false;
    //       });
    //     }
    //   });
    //   console.log(this.collapse_hover);
    /////////////
    // this. connectEventSource();
  },
  mounted: function () {
    let vm = this;
    vm.col_width = vm.$refs.sidenav.clientWidth;
    if (vm.selectPage == "elecboard" || vm.selectPage == "machstatus") {
      vm.slidebar = false;
    } else {
      vm.slidebar = true;
    }
    // vm.sideBar.forEach((item) => {
    //   if (item.children.length != 0) {
    //     this.collapse_hover[item.code] = false;
    //     item.children.forEach((children_item) => {
    //       this.collapse_hover[children_item.code] = false;
    //     });
    //   }
    // });
    // if ("serviceWorker" in navigator) {
    //   navigator.serviceWorker
    //     .register("/sw.js")
    //     .then(registration => console.log("完成 SW 設定!", registration.scope))
    //     .catch(err => console.log("Error!", err));
    // }
  },
  computed: {
    ...mapGetters({
      axiosResult: "commonaxios/get_axiosResult",
      loginData: "getlogin/get_loginData",
      selectPage: "getlogin/get_selectPage",
      pageName: "getlogin/get_pageName",
      pageAccess: "getlogin/get_pageAccess",
      sideBar: "sideBarTree/get_sideBar",
      containerDetailQuery: "containerDetail/get_containerDetailQuery",
      sideBarSelect: "sideBarTree/get_sideBarSelect",
    }),
  },
  components: {
    modal,
    alertModal,
    loadScreenModal,
  },
  watch: {
    slidebar: {
      handler(value) {
        let vm = this;
        if (vm.$refs.sidenav != undefined) {
          vm.col_width = vm.$refs.sidenav.clientWidth;
        }
        vm.set_sideBarLeft(value);
      },
    },
    selectPage: {
      handler(value) {
        let vm = this;
        if (vm.selectPage == "elecboard" || vm.selectPage == "machstatus") {
          vm.slidebar = false;
        } else {
          vm.slidebar = true;
        }

        if (vm.selectPage == "workorderhistory") {
          vm.$nextTick(() => {
            vm.$refs.mainWidget.scrollTop = 0;
          });
        }
      },
    },
    containerDetailQuery: {
      handler() {
        let vm = this;
        if (vm.containerDetailQuery.active) {
          vm.$nextTick(() => {
            vm.$refs.mainWidget.scrollTop = 0;
          });
        }
      },
    },
  },
  methods: {
    ...mapActions({
      axiosAction: "commonaxios/axiosAction",
      change_loginData: "getlogin/change_loginData",
      change_selectPage: "getlogin/change_selectPage",
      change_selectPageName: "getlogin/change_selectPageName",
      change_pageAccess: "getlogin/change_pageAccess",
      toggle_commonModalShow: "usemodal/toggle_commonModalShow",
      set_alertMsg: "alertmodal/set_alertMsg",
      settimeout_alertModal: "alertmodal/settimeout_alertModal",
      set_sideBarSelect: "sideBarTree/set_sideBarSelect",
      set_sideBarLeft: "sideBarTree/set_sideBarLeft",
      set_processOption: "commonqueryiot/set_processOption",
      set_actProcessOption: "commonqueryiot/set_actProcessOption",
      set_htProcessOption: "commonqueryiot/set_htProcessOption",
      set_inspProcessOption: "commonqueryiot/set_inspProcessOption",
      set_orgProcessOption: "commonqueryiot/set_orgProcessOption",
      set_deviceOption: "commonqueryiot/set_deviceOption",
      set_groupOption: "commonqueryiot/set_groupOption",
      do_selectOptionQuery: "commonqueryiot/do_selectOptionQuery",
    }),
    logout() {
      let vm = this;
      var obj = {};
      obj.account = null;
      obj.status = false;
      obj.username = null;
      obj.accesslist = null;
      vm.change_loginData(obj);
      var obj2 = {};
      Object.keys(vm.pageAccess).forEach((key) => {
        obj2[key] = false;
      });
      console.log(obj2);
      vm.change_pageAccess(obj2);
      vm.change_selectPage("");
      vm.change_selectPageName("");
      vm.$router.push("/");
      // window.location.replace("https://192.168.39.73:8885/KingMaker");
    },
    changepwd() {
      let vm = this;
      vm.ChangePwdmodal.wrongStatus =
        vm.$options.data().ChangePwdmodal.wrongStatus;
      vm.ChangePwdmodal.old_pwd = vm.ChangePwdmodal.old_pwd.trim();
      vm.ChangePwdmodal.change_newpwd = vm.ChangePwdmodal.change_newpwd.trim();
      vm.ChangePwdmodal.change_newpwd2 =
        vm.ChangePwdmodal.change_newpwd2.trim();
      if (
        vm.ChangePwdmodal.old_pwd === "" ||
        vm.ChangePwdmodal.change_newpwd === "" ||
        vm.ChangePwdmodal.change_newpwd2 === ""
      ) {
        vm.set_alertMsg("不能為空");
        vm.settimeout_alertModal();
        return;
      }
      if (vm.ChangePwdmodal.old_pwd === vm.ChangePwdmodal.change_newpwd) {
        vm.set_alertMsg("新密碼不能與舊密碼相同");
        vm.settimeout_alertModal();
        vm.ChangePwdmodal.change_newpwd = "";
        vm.ChangePwdmodal.wrongStatus.oldisWrong = true;
        vm.ChangePwdmodal.wrongStatus.new1isWrong = true;
        return;
      }
      vm.ChangePwdmodal.wrongStatus =
        vm.$options.data().ChangePwdmodal.wrongStatus;
      if (vm.ChangePwdmodal.change_newpwd != vm.ChangePwdmodal.change_newpwd2) {
        vm.set_alertMsg("兩次密碼輸入不相符");
        vm.settimeout_alertModal();
        vm.ChangePwdmodal.change_newpwd = "";
        vm.ChangePwdmodal.change_newpwd2 = "";
        vm.ChangePwdmodal.wrongStatus.new1isWrong = true;
        vm.ChangePwdmodal.wrongStatus.new2isWrong = true;
        return;
      }
      vm.ChangePwdmodal.wrongStatus =
        vm.$options.data().ChangePwdmodal.wrongStatus;
      var params = {};
      params["methods"] = "GET";
      params["whichFunction"] = "Login";
      params["uID"] = vm.loginData.account;
      vm.axiosAction(params).then(() => {
        var result = vm.axiosResult;
        if (result["Response"] != "ok") {
          vm.set_alertMsg(result["Response"]);
          vm.settimeout_alertModal();
        } else {
          if (vm.ChangePwdmodal.old_pwd === result["QueryTableData"][0].pwd) {
            params = {};
            params["methods"] = "POST";
            params["whichFunction"] = "ChangePwd";
            params["uID"] = result["QueryTableData"][0].uID;
            params["noumenonType"] = result["QueryTableData"][0].noumenonType;
            params["uInfo"] = result["QueryTableData"][0].uInfo;
            params["accessList"] = JSON.parse(
              result["QueryTableData"][0].accessList
            );
            params["uName"] = result["QueryTableData"][0].uName;
            params["pwd"] = vm.ChangePwdmodal.change_newpwd;
            params["noumenonID"] = result["QueryTableData"][0].noumenonID;
            params["creatorID"] = result["QueryTableData"][0].creatorID;
            vm.axiosAction(params).then(() => {
              var result = vm.axiosResult;
              if (result["Response"] != "ok") {
                vm.set_alertMsg(result["Response"]);
                vm.settimeout_alertModal();
              } else {
                vm.set_alertMsg("修改成功請重新登入");
                vm.settimeout_alertModal();
                var obj = {};
                obj.account = null;
                obj.status = false;
                obj.username = null;
                obj.accesslist = null;
                vm.change_loginData(obj);
                vm.reset();
                vm.toggle_commonModalShow();
                setTimeout(function () {
                  vm.$router.push("/");
                }, 900);
              }
            });
          } else {
            vm.ChangePwdmodal.old_pwd = "";
            vm.ChangePwdmodal.wrongStatus.oldisWrong = true;
            vm.set_alertMsg("舊密碼不符合");
            vm.settimeout_alertModal();
          }
        }
      });
    },
    slidebarChange() {
      let vm = this;
      vm.slidebar = !vm.slidebar;
    },
    askNotification() {
      if (!("Notification" in window)) {
        console.log("This browser does not support notification");
      }
      let vm = this;
      Notification.requestPermission(function (result) {
        // 這裡result只會有兩種結果：一個是用戶允許(granted)，另一個是用戶封鎖(denied)
        console.log("User Choice", result);
        if (result !== "granted") {
          console.log("No notification permission granted!");
        } else {
          // vm.connectEventSource();
        }
      });
    },
    displayConfirmNotification(message) {
      let vm = this;
      var options = {
        body: message.data.msg,
      };
      console.log(message);
      console.log(options);
      // var notification = new Notification(message.data.title, options);
      // // notification.onshow = function() {
      // //   setTimeout(notification.close.bind(notification), 5000);
      // // };
      // notification.onclick = function () {
      //   vm.$router.push("alarmhistory");
      //   vm.change_selectPage("alarmhistory");
      //   vm.change_selectPageName(vm.pageName.alarmhistory);
      //   // window.open("http://localhost:8080/#/index/operatelog", "_blank");
      // };
    },
    connectEventSource() {
      let vm = this;
      if (typeof EventSource !== "undefined") {
        // 指定 Server 檔案路徑
        var sse = new EventSource("/static/php/message.php");

        sse.addEventListener("open", open, false);
        sse.addEventListener("message", message, false);
        sse.addEventListener("error", error, false);
      } else {
        alert("瀏覽器不支援！");
      }

      function open(event) {
        console.log("與 Server 正常連接！");
      }

      function message(event) {
        var pullData = JSON.parse(event.data);
        var MQTTmessage = JSON.parse(pullData.msg);
        vm.displayConfirmNotification(MQTTmessage);
        // var newElement = document.createElement("li");
        // newElement.innerHTML = pullData.name;
        // document.body.appendChild(newElement);
      }

      function error(event) {
        closeEventSource();

        // alert("連接發生錯誤！");
      }

      function closeEventSource() {
        sse.close();

        // alert("已中斷 Server 連線！");
      }
    },
    // sideRightChange(boolean) {
    //   let vm = this;
    //   console.log(vm.sideRight, boolean);
    //   vm.sideRight = boolean;
    // },
    //設定select option
    selectOption() {
      let vm = this;
      var params = {};
      params["vuePage"] = "selectoption";
      params["methods"] = "GET";
      params["whichFunction"] = "SelectOption";
      vm.do_selectOptionQuery(true);
      vm.axiosAction(params).then(() => {
        var result = vm.axiosResult;
        vm.do_selectOptionQuery(false);
        if (result["Response"] == "ok") {
          if (vm.selectPage == "workorderhistory") {
            //工單履歷加入包裝、出貨選項
            result.QueryTableData.process.push({
              value: "package-8",
              text: "包裝",
            });
            result.QueryTableData.process.push({
              value: "container-9",
              text: "出貨",
            });

            result.QueryTableData.device["package-8"] = [
              {
                value: "1",
                text: "01",
              },
              {
                value: "2",
                text: "02",
              },
              {
                value: "3",
                text: "03",
              },
              {
                value: "4",
                text: "04",
              },
              {
                value: "5",
                text: "05",
              },
              {
                value: "6",
                text: "06",
              },
              {
                value: "7",
                text: "07",
              },
              {
                value: "8",
                text: "08",
              },
              {
                value: "9",
                text: "09",
              },
              {
                value: "10",
                text: "10",
              },
              {
                value: "11",
                text: "11",
              },
              {
                value: "12",
                text: "12",
              },
            ];

            result.QueryTableData.device["container-9"] = [
              {
                value: "A1",
                text: "A1",
              },
              {
                value: "A2",
                text: "A2",
              },
              {
                value: "A3",
                text: "A3",
              },
            ];
          }
          if (
            vm.selectPage == "activation" &&
            vm.sideBarSelect.processName == "稼動率日誌"
          ) {
            //稼動率日誌加入包裝選項
            result.QueryTableData.process.push({
              value: 8,
              text: "包裝",
            });
          }
          vm.set_processOption(result.QueryTableData.process);
          vm.set_actProcessOption(result.QueryTableData.actProcess);
          vm.set_htProcessOption(result.QueryTableData.htProcess);
          vm.set_inspProcessOption(result.QueryTableData.inspProcess);
          vm.set_orgProcessOption(result.QueryTableData.orgProcess);
          vm.set_groupOption(result.QueryTableData.group);
          vm.set_deviceOption(result.QueryTableData.device);

        }
      });
    },
    //資料reset
    reset() {
      var def = this.$options.data();
      Object.assign(this.$data, def);
      //https://codepen.io/karimcossutti/pen/ObXyKq
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.index-background-color {
  background-color: #c8c9ca;
}
.index-color {
  color: #646569;
}
.index-navbar-logo {
  height: 35px;
  width: 240px;
  margin-right: 15px;
  padding: 0px;
}
.index-navbar {
  position: relative;
  padding-top: 4px;
  padding-bottom: 4px;
  padding-right: 60px;
  min-height: 60px;
}
/* .nav-item .nav-link {
  color: #eefbf0;
  font-size: 20px;
} */
.username {
  height: 24px;
}
.form-inline a,
.form-inline p {
  color: #eefbf0;
  margin-left: 15px;
}
/* .dropdown-menu {
  margin: 0;
  margin-top: 0px;
  background-color: #9daec8;
  width: 125px !important;
  min-width: 127px !important;
}

.dropdown:hover > .dropdown-menu {
  display: block;
}

.dropleft:hover > .dropdown-menu {
  display: block;
  margin-right: 0px;
}
.dropdown-item {
  padding-left: 10px;
  width: 125px !important;
}
.dropdown-item:hover {
  background-color: #ffffff;
} */
.wrongoldpwd,
.wrongnewpwd1,
.wrongnewpwd2 {
  border: 1px solid red;
}
h5 {
  margin: 0 auto;
}

.navbar {
  margin-bottom: 0;
  border-radius: 0;
}

/* Set height of the grid so .sidenav can be 100% (adjust as needed) */
.row.content {
  height: calc(100vh - 60px);
}
.row.content .main {
  height: calc(100vh - 60px);
  overflow: auto;
}

.sidenav {
  height: calc(100vh - 60px);
}
.sidenav a {
  display: block;
  color: #000;
  text-decoration: none;
  font-size: 20px;
}
.sidenav div {
  color: #646569;
  border-bottom: 2px solid #646569;
  width: 150px;
  height: 60px;
  line-height: 60px;
  font-size: 22px;
  font-family: dfyuanstd-w8, dfyuanstd-w7, dfyuanstd-w5;
}
.sidenav a.active div {
  color: #fff;
}
.sidenav a.disabled div {
  color: #8c8c8c;
}
.sidenav li {
  font-family: "dfyuanstd-w8";
  display: block;
  position: relative;
  background: #c8c9ca;
  color: #646569;
  cursor: pointer;
  height: 60px;
}
.sidenav li ul {
  position: absolute;
  left: 170px;
  width: 170px;
  top: 0px;
  margin: 0;
  padding: 0;
  z-index: 2;
}
/* .right-arrow::after {
  display: inline-block;
  vertical-align: 0;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0;
  border-bottom: 0.3em solid transparent;
  border-left: 0.3em solid;
  float: right;
  margin-top: 0.5em;
  margin-right: 0.5em;
} */
.sidenav li ul li {
  font-family: "dfyuanstd-w8";
  background: #c8c9ca;
  transition: background 0.2s;
}
.sidenav li:hover {
  background: #646569;
}

.sidenav li.active {
  background: #646569;
}
.sidenav li.active > a > div {
  color: #fff;
}

/* On small screens, set height to 'auto' for sidenav and grid */
@media screen and (max-width: 575px) {
  .index-navbar {
    padding-right: 16px;
  }
  .sidenav {
    height: auto;
    width: 100% !important;
  }
  .sidenav .index-version {
    display: none;
  }
  .row.content {
    height: auto;
  }
  .row.content .main {
    height: 100%;
    width: 100% !important;
    overflow: none;
  }
}

</style>
<style lang="scss">
.font-family-dfyuanstd-w5 div {
  font-family: "dfyuanstd-w5";
}
.table-col-hight {
  height: 2.8rem;
}
</style>
<style lang="scss">
.table.b-table > thead > tr > [aria-sort="none"],
.table.b-table > tfoot > tr > [aria-sort="none"] {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='101' height='101' view-box='0 0 101 101' preserveAspectRatio='none'%3e%3cpath fill='white' opacity='.3' d='M51 1l25 23 24 22H1l25-22zM51 101l25-23 24-22H1l25 22z'/%3e%3c/svg%3e");
}
.table.b-table > thead > tr > [aria-sort="ascending"],
.table.b-table > tfoot > tr > [aria-sort="ascending"] {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='101' height='101' view-box='0 0 101 101' preserveAspectRatio='none'%3e%3cpath fill='white' d='M51 1l25 23 24 22H1l25-22z'/%3e%3cpath fill='white' opacity='.3' d='M51 101l25-23 24-22H1l25 22z'/%3e%3c/svg%3e");
}
.table.b-table > thead > tr > [aria-sort="descending"],
.table.b-table > tfoot > tr > [aria-sort="descending"] {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='101' height='101' view-box='0 0 101 101' preserveAspectRatio='none'%3e%3cpath fill='white' opacity='.3' d='M51 1l25 23 24 22H1l25-22z'/%3e%3cpath fill='white' d='M51 101l25-23 24-22H1l25 22z'/%3e%3c/svg%3e");
}
.mes-modal-title {
  background-color: #4b8c80;
  height: 40px;
}
.mes-modal-title > button.close {
  color: #ffffff;
  opacity: 1;
  padding: 0.5rem 0.5rem;
}
.mes-modal-title > button.close:hover {
  color: #ffffff;
}
</style>


// WEBPACK FOOTER //
// src/views/Index.vue